define('rebrush/components/gigaset_customprint/view',[
    'jquery',
    'lodash',
    'fabric',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'jquery-form',
    'magnific-popup'
], function(
    $,
    _,
    fabric,
    Component,
    BEM
) {
    function ObserverImageLoaded(callback) {
        this.callback = callback;
    }

    ObserverImageLoaded.prototype = {
        callback: null,
        backgroundLoaded: false,
        overlayLoaded: false,

        checkFulfilled: function () {
            if (this.backgroundLoaded && this.overlayLoaded) {
                this.callback();
            }
        }
    };

    function View(dialogBlock) {
        this.dialogBlock = dialogBlock;
    }

    View.prototype = {
        dialogBlock: null,
        cta: null,
        optionInput: null,
        addToCart: null,
        canvas: null,
        stencilImage: null,
        baseImage: null,
        alertBox: null,
        fileExtensions: 'png|jpeg|jpg',
        globalScale: null,
        dimensions: null,
        thumbnail: false,
        localscale: 1,
        progressBar: null,
        previewElement: null,
        previewWrapper: null,
        data: null,
        tokenHash: null,

        initializeComponent: function() {
			let optionsBlock = this.dialogBlock.closest('.' + BEM.buildElementClassname('product-options','option-wrap')),
                popup = this.dialogBlock,
                self = this;

			this.cta = optionsBlock.find('.' + BEM.buildElementClassname('product-options','custom-print-open-configurator'));
			this.previewElement = optionsBlock.find('.' + BEM.buildElementClassname('product-options','custom-print-preview') + ' img');
			this.previewWrapper = this.previewElement.parent();
			this.optionInput = optionsBlock.find('.product-custom-option-print');
			this.dimensions = popup.data('dimensions');

			this.previewWrapper.find('.' + BEM.buildElementClassname('product-options','custom-print-preview-reset')).on('click', function (e) {
			    e.preventDefault();
			    self.reset();
            });

			this.optionInput.on('change', function () {
			    if (!$(this).val()) {
                    self.previewElement.attr('src', '');
                    self.previewWrapper.hide();
                    opConfig.reloadPrice();

                    if (!self.cta.hasClass('btn')) {
                        self.cta.addClass('btn');
                    }

                    if (!self.cta.hasClass('btn-primary')) {
                        self.cta.addClass('btn-primary');
                    }
                }
            });

			this.initPopup(popup);
		},

        initPopup: function (popup) {
            let self = this;
            function openCallback() {
                self.thumbnail = null;

                let canvas = this.contentContainer.find('canvas');

                self.stencilImage = this.contentContainer.find('img.image-stencil'),
                self.baseImage = this.contentContainer.find('img.image-base');

                self.progressBar = this.contentContainer.find('.progress-bar');
                self.alertBox = this.contentContainer.find('.alert');

                self.initCanvas(canvas[0], self.baseImage, self.stencilImage);
                self.initActions(this.contentContainer);
            }

            this.cta.on('click', function(event) {
                event.preventDefault();
                event.stopPropagation();

                // holding main popup window content in DOM element
                let hiddenPopupContainer = $('.data-essential-product-popup-holder');
                if(hiddenPopupContainer.length) {
                    hiddenPopupContainer.remove();
                }
                let mainPopup = $('.mfp-content .popup-wrap');

                if($.magnificPopup.instance.isOpen) {
                    setTimeout(function() {
                        openCallback.call($.magnificPopup.instance);
                    }, 0);
                }

                $.magnificPopup.open({
                    closeOnContentClick: false,
                    closeOnBgClick: false,
                    closeBtnInside: true,
                    items: [
                        {
                            type: 'inline',
                            src: popup.html(),
                        }
                    ],
                    callbacks: {
                        open: openCallback,
                        close: function () {
                            if (!self.thumbnail) {
                                return;
                            }

                            self.canvas = null;
                            self.thumbnail = null;
                        }
                    }
                });

                let containerPopup = $('<div class="data-essential-product-popup-holder" style="display: none"></div>');
                $('body').append(containerPopup);
                containerPopup.append(mainPopup);
            });

            $(window).on('resize', function () {
                self.resizeCanvas();
            });

			this.cta.removeAttr('disabled');
        },

        initCanvas: function (canvas, background, stencil) {
            let fCanvas = new fabric.Canvas(canvas),
                self = this;
            fCanvas.controlsAboveOverlay = true;

            if (!this.dimensions.fullscale) {
                let border = $('<div />');
                border.addClass('border');
                border.css({
                    width: this.dimensions.width + 2,
                    height: this.dimensions.height + 2,
                    left: this.dimensions.widthOffset - 1,
                    top: this.dimensions.heightOffset - 1
                });

                $(fCanvas.wrapperEl).append(border);
            }

            let callback = function () {
                self.originalWidth = fCanvas.getWidth();
                self.originalHeight = fCanvas.getHeight();

                self.resizeCanvas();
            };

            let observer = new ObserverImageLoaded(callback);

            fabric.Image.fromURL(background.attr('src'), function (image) {
                fCanvas.setBackgroundImage(image, fCanvas.renderAll.bind(fCanvas));
                fCanvas.setWidth(image.width);
                fCanvas.setHeight(image.height);

                observer.backgroundLoaded = true;
                observer.checkFulfilled();
            });

            fabric.Image.fromURL(stencil.attr('src'), function (image) {
                fCanvas.setOverlayImage(image, fCanvas.renderAll.bind(fCanvas));
                observer.overlayLoaded = true;
                observer.checkFulfilled();
            });

            if (this.optionInput.val()) {

                let inputValue = JSON.parse(this.optionInput.val());

                fabric.Image.fromURL(inputValue.baseUrl + inputValue.uploadImage, function(image) {

                    self.localScale = self.dimensions.width / image.width;

                    image.set('top', (self.dimensions.heightOffset + inputValue.offsetY) * self.globalScale);
                    image.set('left', (self.dimensions.widthOffset + inputValue.offsetX) * self.globalScale);
                    image.scale(self.globalScale * inputValue.scale * self.localScale);
                    image.setControlsVisibility({ml: false, mb: false, mr: false, mt: false, mtr: false});
                    image.lockScalingFlip = true;
                    image.transparentCorners = false;
                    image.name = 'customprint-image';

                    image.on('scaling', function () {
                        self.toogleAlert('');

                        let maxScale = self.data.maxScale * self.globalScale * self.localScale;

                        if (this.scaleX > maxScale) {
                            this.scaleX = maxScale;
                            this.scaleY = maxScale;

                            self.toogleAlert(Translator.translate('Image cannot be scaled larger for print.'));
                        }
                    });

                    self.thumbnail = image;
                    fCanvas.add(self.thumbnail);
                    fCanvas.setActiveObject(self.thumbnail);
                });
            }

			this.canvas = fCanvas;
        },

        initActions: function(container) {

            let self = this,
                uploadInput = container.find('input[type="file"]')[0],
                form = container.find('form'),
                saveButton = container.find('.' + BEM.buildElementClassname('print-dialog','print-file-input-save')),
                cancelButton = container.find('.' + BEM.buildElementClassname('print-dialog','print-file-input-cancel'));

            if (this.optionInput.val()) {
                saveButton.show();
                cancelButton.hide();
            }

            $(uploadInput).on('change', function () {
                $(this).siblings('span.filename-label').html(this.files[0].name);
            });

            container.on('click', '.' + BEM.buildElementClassname('print-dialog','print-file-input-submit'), function (event) {
                event.preventDefault();

                self.progressBar.animate(
                    {width: '0'},
                    {duration: 0}
                );

                self.toogleAlert('');

			    let file = uploadInput.files[0];

			    if (typeof file === 'undefined') {
			        self.toogleAlert(Translator.translate('Please select a file first.'));
			        return false;
                }

			    let fileType = file.type.split('/');

			    if (fileType[0] !== 'image' || !RegExp(self.fileExtensions).test(fileType[1])) {
			        let message = Translator.translate('File extension is not allowed. Allowed extensions are %s.');
			        message = message.replace('{0}', self.fileExtensions.replace('|', ', '));

			        self.toogleAlert(message);
			        return false;
                }


			    if (self.thumbnail) {
			        self.canvas.remove(self.thumbnail);
                }

                form.ajaxSubmit({
                    beforeSubmit: function () {
                        self.progressBar.width('50%');
                    },
                    uploadProgress: function (event, position, total, percentageComplete) {
                        self.progressBar.animate(
                            {width: percentageComplete + '%'},
                            {duration: 10}
                        );
                    },
                    success: function (response) {
                        self.tokenHash = response.tokenHash;
                        self.data = {
                            uploadImage: response.imageUrl,
                            tokenHash: response.tokenHash,
                            offsetX: 0,
                            offsetY: 0,
                            scale: 1,
                            maxScale: response.maxScale
                        };

                        saveButton.show();
                        cancelButton.hide();

                        fabric.Image.fromURL(response.baseUrl + response.imageUrl, function(image) {
                            self.localScale = self.dimensions.width / image.width;

                            let initialScale = self.data.maxScale < 1 ? self.data.maxScale : 1;

                            if (initialScale < 1) {
                                self.toogleAlert(Translator.translate('Image cannot be scaled larger for print.'));
                            }

                            image.set('top', self.dimensions.heightOffset * self.globalScale);
                            image.set('left', self.dimensions.widthOffset * self.globalScale);
                            image.scale(self.globalScale * self.localScale * initialScale);
                            image.setControlsVisibility({ml: false, mb: false, mr: false, mt: false, mtr: false});
                            image.lockScalingFlip = true;
                            image.transparentCorners = false;
                            image.name = 'customprint-image';

                            image.on('scaling', function () {
                                self.toogleAlert('');

                                let maxScale = self.data.maxScale * self.globalScale * self.localScale;

                                if (this.scaleX > maxScale) {
                                    this.scaleX = maxScale;
                                    this.scaleY = maxScale;

                                    self.toogleAlert(Translator.translate('Image cannot be scaled larger for print.'));
                                }
                            });

                            self.thumbnail = image;
                            self.canvas.add(self.thumbnail);
                            self.canvas.setActiveObject(self.thumbnail);
                        });
                    },
                    error: function (response) {
                        self.toogleAlert(response.responseJSON.message);

                        self.progressBar.animate(
                            {width: '0'},
                            {duration: 0}
                        );
                    }
                });
            });

            saveButton.on('click', function (event) {
                event.preventDefault();

                if (self.dimensions.forceFill) {

                    var printFrameWidth = self.dimensions.width;
                    var printFrameHeight = self.dimensions.height;

                    var userInputWidth = self.thumbnail.get('scaleX') * self.thumbnail.get('width');
                    var userInputHeight = self.thumbnail.get('scaleY') * self.thumbnail.get('height');

                    var userInputCordinates = self.thumbnail.get('oCoords');

                    var printFrameTopLeftY = self.dimensions.heightOffset;
                    var printFrameTopLeftX = self.dimensions.widthOffset;
                    var printFrameBottomRightY = printFrameTopLeftY + printFrameHeight;
                    var printFrameBottomRightX = printFrameTopLeftX + printFrameWidth;

                    var frameSizeFilled = userInputWidth > printFrameWidth && userInputHeight > printFrameHeight;
                    var yAxisFrameFilled = userInputCordinates.tl.y < printFrameTopLeftY && userInputCordinates.br.y > printFrameBottomRightY;
                    var xAxisFrameFilled = userInputCordinates.tl.x < printFrameTopLeftX && userInputCordinates.br.x > printFrameBottomRightX;

                    if (!frameSizeFilled || !yAxisFrameFilled || !xAxisFrameFilled) {
                        self.toogleAlert(Translator.translate('Please fill the complete print frame (orange borders) or use the passepartout print option instead.'));
                        return false;
                    }
                }

                if (self.thumbnail) {
                    self.data.offsetX = (self.thumbnail.get('left') / self.globalScale) - self.dimensions.widthOffset;
                    self.data.offsetY = (self.thumbnail.get('top') / self.globalScale) - self.dimensions.heightOffset;
                    self.data.scale = (self.thumbnail.get('scaleX') / self.globalScale / self.localScale);
                    self.data.canvasWidth = self.canvas.width;
                    self.data.canvasHeight = self.canvas.height;

                    $.ajax({
                        url: self.cta.data('generate-preview-action'),
                        data: {
                            hash: self.tokenHash,
                            data: self.data,
                        },
                        method: 'post',
                        success: function (response) {

                            let preview = response.preview;

                            self.data.preview = preview;
                            self.data.baseUrl = response.baseUrl;
                            self.previewElement.attr('src', response.baseUrl + preview);
                            self.previewWrapper.show();

                            self.optionInput.val(JSON.stringify(self.data));
                            opConfig && opConfig.reloadPrice();

                            self.cta.removeClass('btn');
                            self.cta.removeClass('btn-primary');
                        }
                    });
                }

                BEM.block('product-detail-add-to-cart').getElements('add-to-cart-button').attr('data-customprint-added', 1);

                if($('.catalog-category-view').length) {
                    self.backToMainPopup();
                } else {
                    $.magnificPopup.close();
                }
            });

            cancelButton.on('click', function (event) {
                event.preventDefault();
                if($('.catalog-category-view').length) {
                    self.backToMainPopup();
                } else {
                    $.magnificPopup.close();
                }
            });
        },

        backToMainPopup: function () {
            let hiddenPopupContainer = $('.data-essential-product-popup-holder');
            if(hiddenPopupContainer.length) {
                $.magnificPopup.open({
                    items: [
                        {
                            type: 'inline',
                            src: hiddenPopupContainer.children().first(),
                        }
                    ],
                });
                hiddenPopupContainer.remove();
            }
        },

        toogleAlert: function (message) {
            this.alertBox.html(message);

            if (message === '') {
                this.alertBox.addClass('empty');
                return;
            }

            this.alertBox.removeClass('empty');
        },

        resizeCanvas: function () {
            if (this.canvas === null) {
                return;
            }

            let width = window.innerWidth-50,
                canvasWidth = this.canvas.getWidth();

            if (canvasWidth > width) {
                this.globalScale = width / canvasWidth;

                let ratio = this.originalHeight / this.originalWidth;

                this.resizeCanvasTo(width, width * ratio);
            } else if (width >= this.originalWidth) {
                this.globalScale = 1;

                this.resizeCanvasTo(this.originalWidth, this.originalHeight);
            }
        },

        resizeCanvasTo: function (width, height) {
            this.canvas.setWidth(width);
            this.canvas.setHeight(height);

            let scale = width/this.originalWidth;

            this.canvas.backgroundImage.scale(scale);
            this.canvas.overlayImage.scale(scale);

            if (this.thumbnail) {
                this.canvas.remove(this.thumbnail);
                this.thumbnail = null;
            }

            let border = $(this.canvas.wrapperEl).find('.border');

            if (border.length > 0) {
                border.css({
                    width: this.dimensions.width * scale + 2,
                    height: this.dimensions.height * scale + 2,
                    left: this.dimensions.widthOffset * scale - 1,
                    top: this.dimensions.heightOffset * scale - 1
                });
            }

            this.canvas.calcOffset();
            this.canvas.renderAll();
        },

        reset: function () {
            this.data.preview = null;
            this.previewElement.attr('src', '');
            this.previewWrapper.hide();

            this.optionInput.val('');

            if (!this.cta.hasClass('btn')) {
                this.cta.addClass('btn');
            }
            if (!this.cta.hasClass('btn-primary')) {
                this.cta.addClass('btn-primary');
            }
        }
    };

    return Component.create({
        $init: function () {
            fabric.Object.prototype.cornerColor = '#ff5200';

            var dialogBlocks = $('script[data-identifier="print-dialog"]');

            dialogBlocks.each(function () {
                (new View($(this))).initializeComponent();
            });
        }
    });
});
